let pendingResolve: ((token: string) => void) | null = null;
let pendingPromise: Promise<string> | null = null;
let pendingTimer: ReturnType<typeof setTimeout> | null = null;

export const getAccessToken = () => localStorage.getItem("accessToken") || "";

export const setAccessToken = (token: string) => {
  localStorage.setItem("accessToken", token || "");
  if (pendingResolve) {
    pendingResolve(token || "");
    pendingResolve = null;
  }
  if (pendingTimer) {
    clearTimeout(pendingTimer);
    pendingTimer = null;
  }
};

export const requestAccessToken = (): Promise<string> => {
  if (pendingPromise) {
    return pendingPromise;
  }
  pendingPromise = new Promise<string>((resolve) => {
    pendingResolve = resolve;
    window.parent.postMessage({ action: "getAccessToken" }, "*");
    pendingTimer = setTimeout(() => {
      if (pendingResolve) {
        pendingResolve("");
        pendingResolve = null;
      }
      pendingTimer = null;
    }, 3000);
  }).finally(() => {
    pendingPromise = null;
  });
  return pendingPromise;
};

export const fetchWithToken = async (input: RequestInfo | URL, init: RequestInit = {}) => {
  const doFetch = (token: string) =>
    fetch(input, {
      ...init,
      headers: {
        ...(init.headers || {}),
        Authorization: token,
      },
    });

  let response = await doFetch(getAccessToken());
  if (response.status === 401) {
    const token = await requestAccessToken();
    if (token) {
      response = await doFetch(token);
    }
  }
  return response;
};
